import React from 'react';
import styled, {css} from 'styled-components/macro';
import {Draggable} from 'react-beautiful-dnd';

const getBoxShadow = (props) => {
  if (props.isDragDisabled) return css`
    box-shadow: inset 1px 1px rgba(0,0,0,0.2);
    &:hover {
      box-shadow: inset 1px 1px rgba(0,0,0,0.2);
    }
  `; 
  return (props.isDragging ? css`
    box-shadow: 10px 20px 15px rgba(0,0,0,0.2);
  ` : css`
    box-shadow: 0.5px 0.5px rgba(0,0,0,0.3);
  `
)}


const Container = styled.div`
  border-radius: 50%;
  border: 1px solid lightgrey;
  width: 40px;
  height: 40px;
  padding: 8px;
  display: flex;
  background-color: ${props => props.isDragDisabled ? 'lightgrey' :'white'};
  transition: box-shadow 0.3s ease-in-out;
  &:hover, &:focus {
    //x, y, blur, color
    //x, y, blur, spread, color
    box-shadow: 0px 5px 15px rgba(0,0,0,0.3);
    // raise to attention
    transition: transform 0.2s ease-out;
    transform: scale(1.005);
  }
  &:active {
    // Grab feedback
    transition: transform 0.1s ease;
    transform: translate(1%, 2%) scale(1.003) rotate(0.3deg);

  }
  &:focus {
    background-color: pink;
    outline: none;
  }
  ${getBoxShadow};
  margin-right: 8px;
  justify-content: center;
  align-items: center;
`;


export default class Task extends React.Component {
  render() {
    const isDragDisabled = this.props.task.id === 'task-2';
    return (
      <Draggable 
        draggableId={this.props.task.id}
        index={this.props.index}
        isDragDisabled={isDragDisabled}
      >
        {(provided, snapshot) => (
          <Container
            {...provided.draggableProps}
            ref={provided.innerRef}
            isDragging={snapshot.isDragging}
            isDragDisabled={isDragDisabled}
            {...provided.dragHandleProps} //can drag a large component with a small part of it
          >
            {this.props.task.content[0]}
          </Container>
        )}
      </Draggable>
    )
  }
}
